import dynamic from 'next/dynamic';
import styles from './api-error-block.module.scss';
import { Trans } from 'react-i18next';

const Button = dynamic(() => import('core/generic/elements/button'), {
    ssr: false,
});
const InfoBlock = dynamic(() => import('core/generic/elements/info-block'), {
    ssr: false,
});

export const ApiErrorBlock = ({
    apiErrorMessage,
}: {
    apiErrorMessage: string;
}) => {
    return (
        <>
            {apiErrorMessage && (
                <InfoBlock variant="error">
                    <div className={styles['error-info-block']}>
                        <p className="body-small">
                            <Trans
                                i18nKey={apiErrorMessage}
                                components={[
                                    <Button
                                        variant="link"
                                        dimension="medium"
                                        className={styles['inline-button']}
                                    />,
                                ]}
                            />
                        </p>
                    </div>
                </InfoBlock>
            )}
        </>
    );
};
